import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/LinksView/desktop/LinksView.desktop.module.scss';
import Icon from 'components/common/Icons/icon';
import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCard.types';
import { UseFormWatch } from 'react-hook-form';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';
import React from 'react';

type ExternalDocument = IFields['externalDocuments'][0];
type ExternalDocumentLink = IFields['externalLinks'][0];

interface Props {
    watch: UseFormWatch<IFields>;
    handleDeleteAssociatedDocumentsLinks: (index: number) => void;
    handleDeleteAssociatedDocuments: (id: number) => void;
    handleDownloadExternalDocument: (documentId: number, fileName: string) => void;
}

export const LinksViewDesktop = ({
    watch,
    handleDeleteAssociatedDocumentsLinks,
    handleDeleteAssociatedDocuments,
    handleDownloadExternalDocument,
}: Props) => {
    const externalDocuments = watch('externalDocuments');
    const hasExternalDocumentsProperty = externalDocuments !== undefined;
    const externalLinks = watch('externalLinks');

    return (
        <div className={classes.linksView}>
            <ul id={'cardModalExternalLinks'}>
                {externalLinks.map((item: ExternalDocumentLink, index: number) => (
                    <li key={item.title}>
                        <div className={classes.LinkWrapper}>
                            <MuiIcon icon={'link'} fontSize="3rem" />
                            <a href={item.url} target="_blank">
                                {item.title}
                            </a>
                        </div>
                        <span
                            className={classes.deleteIcon}
                            onClick={() => {
                                handleDeleteAssociatedDocumentsLinks(index);
                            }}
                        >
                            <Icon name="filter-x-icon" size="22" color="red" />
                        </span>
                    </li>
                ))}
            </ul>
            {hasExternalDocumentsProperty && (
                <ul id={'cardModalExternalDocuments'}>
                    {externalDocuments
                        .filter((document: ExternalDocument) => document.delete === undefined)
                        .map((document: ExternalDocument) => {
                            return (
                                <li key={document?.id}>
                                    <div className={classes.LinkWrapper}>
                                        <MuiIcon icon={'article'} fontSize="3rem" />
                                        <div
                                            onClick={() => {
                                                handleDownloadExternalDocument(document.id, document.name);
                                            }}
                                            className={classes.documentLink}
                                        >
                                            {document.name}
                                        </div>
                                    </div>
                                    <span
                                        className={classes.deleteIcon}
                                        onClick={() => {
                                            handleDeleteAssociatedDocuments(document.id);
                                        }}
                                    >
                                        <Icon name="filter-x-icon" size="22" color="red" />
                                    </span>
                                </li>
                            );
                        })}
                </ul>
            )}
        </div>
    );
};
